import "@/App.css";
import RadioApp from "@/pages/RadioApp";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <RadioApp />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
